var emailRegexpInstance = undefined;
function getRegExp() {
  if (!emailRegexpInstance) {
    // A bit more complex email regexp with unicode support
    // ((Any valid symbols).(Any valid symbols).... | "any symbols")@([ip address] | domain.com)
    var pattern = '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|("[^"]+"))@' + '((\\[\\d{1,3}.\\d{1,3}.\\d{1,3}.\\d{1,3}\\])|(([\\p{Alpha}\\-0-9]+\\.)+\\p{Alpha}{2,}))$'; // eslint-disable-next-line @typescript-eslint/no-var-requires

    var rewritePattern = require('regexpu-core'); // transpile unicode patterns for ES5 support

    var transpiled = rewritePattern(pattern, 'u', {
      unicodePropertyEscape: true
    });
    emailRegexpInstance = new RegExp(transpiled);
  }
  return emailRegexpInstance;
}
/**
 * @description Строгий валидатор email с расширенным регулярным выражением.
 *
 * @warn Нужно использовать только в тех местах, где требуется дополнительная защита от
 * опечаток и некорректных значений. В простых случаях сбора пользовательских данных,
 * или когда данные приходят изнутри m2, следует использовать упрощённый validateEmail
 */

var validEmailStrict = function validEmailStrict(_a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.message,
    message = _c === void 0 ? 'Введите корректный e-mail' : _c,
    _d = _b.emptyMessage,
    emptyMessage = _d === void 0 ? 'Введите e-mail' : _d,
    _e = _b.required,
    required = _e === void 0 ? true : _e;
  return function (value) {
    if (!value || !value.trim()) {
      return required ? emptyMessage : undefined;
    }
    return getRegExp().test(value) ? undefined : message;
  };
};
export { validEmailStrict };